"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateSynapseProblemServiceServer = exports.PrivateSynapseProblemServiceDispatcher = exports.PrivateSynapseProblemServiceClient = void 0;
var RegisteredProblems_1 = require("./RegisteredProblems");
var SynapseProblem_1 = require("./SynapseProblem");
var StatQuery_1 = require("./StatQuery");
var SynapseProblemSchemaSampleJson_1 = require("./SynapseProblemSchemaSampleJson");
var SynapseInternalID_1 = require("./SynapseInternalID");
var services_shared_1 = require("@playq/services-shared");
var QueryDatasetResponse_1 = require("./QueryDatasetResponse");
var SynapseProblemSchema_1 = require("./SynapseProblemSchema");
var DatasetFormat_1 = require("./DatasetFormat");
var SynapseTestResult_1 = require("./SynapseTestResult");
var ProblemStats_1 = require("./ProblemStats");
var irt_1 = require("@playq/irt");
var InRegisterProblem = (function () {
    function InRegisterProblem(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.app = new services_shared_1.AppId(data.app);
        this.problem = new SynapseProblem_1.SynapseProblem(data.problem);
        this.id = typeof data.id !== 'undefined' ? new SynapseInternalID_1.SynapseInternalID(data.id) : undefined;
    }
    Object.defineProperty(InRegisterProblem.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRegisterProblem.prototype, "problem", {
        get: function () {
            return this._problem;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field problem is not optional');
            }
            this._problem = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRegisterProblem.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._id = undefined;
                return;
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InRegisterProblem.prototype.serialize = function () {
        return {
            app: this.app.serialize(),
            problem: this.problem.serialize(),
            id: typeof this.id !== 'undefined' ? this.id.serialize() : undefined
        };
    };
    return InRegisterProblem;
}());
var OutRegisterProblemHelpers = (function () {
    function OutRegisterProblemHelpers() {
    }
    OutRegisterProblemHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRegisterProblemHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new SynapseInternalID_1.SynapseInternalID(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRegisterProblemHelpers;
}());
var InRetrieveProblem = (function () {
    function InRetrieveProblem(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new SynapseInternalID_1.SynapseInternalID(data.id);
    }
    Object.defineProperty(InRetrieveProblem.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InRetrieveProblem.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InRetrieveProblem;
}());
var OutRetrieveProblemHelpers = (function () {
    function OutRetrieveProblemHelpers() {
    }
    OutRetrieveProblemHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRetrieveProblemHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new SynapseProblem_1.SynapseProblem(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRetrieveProblemHelpers;
}());
var InUpdateProblem = (function () {
    function InUpdateProblem(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new SynapseInternalID_1.SynapseInternalID(data.id);
        this.problem = new SynapseProblem_1.SynapseProblem(data.problem);
    }
    Object.defineProperty(InUpdateProblem.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateProblem.prototype, "problem", {
        get: function () {
            return this._problem;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field problem is not optional');
            }
            this._problem = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateProblem.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            problem: this.problem.serialize()
        };
    };
    return InUpdateProblem;
}());
var OutUpdateProblemHelpers = (function () {
    function OutUpdateProblemHelpers() {
    }
    OutUpdateProblemHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateProblemHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateProblemHelpers;
}());
var InUnregisterItem = (function () {
    function InUnregisterItem(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new SynapseInternalID_1.SynapseInternalID(data.id);
    }
    Object.defineProperty(InUnregisterItem.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InUnregisterItem.prototype.serialize = function () {
        return {
            id: this.id.serialize()
        };
    };
    return InUnregisterItem;
}());
var OutUnregisterItemHelpers = (function () {
    function OutUnregisterItemHelpers() {
    }
    OutUnregisterItemHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUnregisterItemHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUnregisterItemHelpers;
}());
var InGetRegisteredProblems = (function () {
    function InGetRegisteredProblems(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.app = new services_shared_1.AppId(data.app);
    }
    Object.defineProperty(InGetRegisteredProblems.prototype, "app", {
        get: function () {
            return this._app;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field app is not optional');
            }
            this._app = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetRegisteredProblems.prototype.serialize = function () {
        return {
            app: this.app.serialize()
        };
    };
    return InGetRegisteredProblems;
}());
var OutGetRegisteredProblemsHelpers = (function () {
    function OutGetRegisteredProblemsHelpers() {
    }
    OutGetRegisteredProblemsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutGetRegisteredProblemsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new RegisteredProblems_1.RegisteredProblems(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutGetRegisteredProblemsHelpers;
}());
var InCheckRegisteredProblems = (function () {
    function InCheckRegisteredProblems(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.ids = data.ids.map(function (e) { return new SynapseInternalID_1.SynapseInternalID(e); });
    }
    Object.defineProperty(InCheckRegisteredProblems.prototype, "ids", {
        get: function () {
            return this._ids;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field ids is not optional');
            }
            this._ids = value;
        },
        enumerable: false,
        configurable: true
    });
    InCheckRegisteredProblems.prototype.serialize = function () {
        return {
            ids: this.ids.map(function (e) { return e.serialize(); })
        };
    };
    return InCheckRegisteredProblems;
}());
var OutCheckRegisteredProblemsHelpers = (function () {
    function OutCheckRegisteredProblemsHelpers() {
    }
    OutCheckRegisteredProblemsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutCheckRegisteredProblemsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new RegisteredProblems_1.RegisteredProblems(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutCheckRegisteredProblemsHelpers;
}());
var InGetStats = (function () {
    function InGetStats(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new SynapseInternalID_1.SynapseInternalID(data.id);
        this.version = data.version;
        this.query = new StatQuery_1.StatQuery(data.query);
    }
    Object.defineProperty(InGetStats.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetStats.prototype, "version", {
        get: function () {
            return this._version;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field version is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field version expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field version is expected to be an integer, got ' + value);
            }
            if (value < 0) {
                throw new Error('Field version is expected to be not less than 0, got ' + value);
            }
            if (value > 4294967295) {
                throw new Error('Field version is expected to be not greater than 4294967295, got ' + value);
            }
            this._version = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetStats.prototype, "query", {
        get: function () {
            return this._query;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field query is not optional');
            }
            this._query = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetStats.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            version: this.version,
            query: this.query.serialize()
        };
    };
    return InGetStats;
}());
var OutGetStatsHelpers = (function () {
    function OutGetStatsHelpers() {
    }
    OutGetStatsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutGetStatsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new ProblemStats_1.ProblemStats(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutGetStatsHelpers;
}());
var InQueryDataset = (function () {
    function InQueryDataset(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new SynapseInternalID_1.SynapseInternalID(data.id);
        this.version = data.version;
        this.offset = new services_shared_1.OffsetLimit(data.offset);
        this.format = DatasetFormat_1.DatasetFormat[data.format];
    }
    Object.defineProperty(InQueryDataset.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryDataset.prototype, "version", {
        get: function () {
            return this._version;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field version is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field version expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field version is expected to be an integer, got ' + value);
            }
            if (value < 0) {
                throw new Error('Field version is expected to be not less than 0, got ' + value);
            }
            if (value > 4294967295) {
                throw new Error('Field version is expected to be not greater than 4294967295, got ' + value);
            }
            this._version = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryDataset.prototype, "offset", {
        get: function () {
            return this._offset;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field offset is not optional');
            }
            this._offset = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryDataset.prototype, "format", {
        get: function () {
            return this._format;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field format is not optional');
            }
            this._format = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryDataset.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            version: this.version,
            offset: this.offset.serialize(),
            format: DatasetFormat_1.DatasetFormat[this.format]
        };
    };
    return InQueryDataset;
}());
var OutQueryDatasetHelpers = (function () {
    function OutQueryDatasetHelpers() {
    }
    OutQueryDatasetHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryDatasetHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new QueryDatasetResponse_1.QueryDatasetResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryDatasetHelpers;
}());
var InProblemSchema = (function () {
    function InProblemSchema(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new SynapseInternalID_1.SynapseInternalID(data.id);
        this.problem = new SynapseProblem_1.SynapseProblem(data.problem);
    }
    Object.defineProperty(InProblemSchema.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InProblemSchema.prototype, "problem", {
        get: function () {
            return this._problem;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field problem is not optional');
            }
            this._problem = value;
        },
        enumerable: false,
        configurable: true
    });
    InProblemSchema.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            problem: this.problem.serialize()
        };
    };
    return InProblemSchema;
}());
var OutProblemSchemaHelpers = (function () {
    function OutProblemSchemaHelpers() {
    }
    OutProblemSchemaHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutProblemSchemaHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new SynapseProblemSchema_1.SynapseProblemSchema(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutProblemSchemaHelpers;
}());
var InProblemSchemaSampleJson = (function () {
    function InProblemSchemaSampleJson(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new SynapseInternalID_1.SynapseInternalID(data.id);
        this.problem = new SynapseProblem_1.SynapseProblem(data.problem);
    }
    Object.defineProperty(InProblemSchemaSampleJson.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InProblemSchemaSampleJson.prototype, "problem", {
        get: function () {
            return this._problem;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field problem is not optional');
            }
            this._problem = value;
        },
        enumerable: false,
        configurable: true
    });
    InProblemSchemaSampleJson.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            problem: this.problem.serialize()
        };
    };
    return InProblemSchemaSampleJson;
}());
var OutProblemSchemaSampleJsonHelpers = (function () {
    function OutProblemSchemaSampleJsonHelpers() {
    }
    OutProblemSchemaSampleJsonHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutProblemSchemaSampleJsonHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new SynapseProblemSchemaSampleJson_1.SynapseProblemSchemaSampleJson(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutProblemSchemaSampleJsonHelpers;
}());
var InTestProblem = (function () {
    function InTestProblem(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.id = new SynapseInternalID_1.SynapseInternalID(data.id);
        this.iterations = data.iterations;
    }
    Object.defineProperty(InTestProblem.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InTestProblem.prototype, "iterations", {
        get: function () {
            return this._iterations;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterations is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field iterations expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field iterations is expected to be an integer, got ' + value);
            }
            this._iterations = value;
        },
        enumerable: false,
        configurable: true
    });
    InTestProblem.prototype.serialize = function () {
        return {
            id: this.id.serialize(),
            iterations: this.iterations
        };
    };
    return InTestProblem;
}());
var OutTestProblemHelpers = (function () {
    function OutTestProblemHelpers() {
    }
    OutTestProblemHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutTestProblemHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new SynapseTestResult_1.SynapseTestResult(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutTestProblemHelpers;
}());
var PrivateSynapseProblemServiceClient = (function () {
    function PrivateSynapseProblemServiceClient(transport) {
        this._transport = transport;
    }
    PrivateSynapseProblemServiceClient.prototype.getPackageName = function () { return PrivateSynapseProblemServiceClient.PackageName; };
    PrivateSynapseProblemServiceClient.prototype.getClassName = function () { return PrivateSynapseProblemServiceClient.ClassName; };
    PrivateSynapseProblemServiceClient.prototype.getFullClassName = function () { return PrivateSynapseProblemServiceClient.FullClassName; };
    PrivateSynapseProblemServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateSynapseProblemServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateSynapseProblemServiceClient.prototype.registerProblem = function (app, problem, id) {
        var _this = this;
        var __data = new InRegisterProblem();
        __data.app = app;
        __data.problem = problem;
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateSynapseProblemServiceClient.ClassName, 'registerProblem', __data)
                .then(function (data) {
                try {
                    resolve(OutRegisterProblemHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateSynapseProblemServiceClient.prototype.retrieveProblem = function (id) {
        var _this = this;
        var __data = new InRetrieveProblem();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateSynapseProblemServiceClient.ClassName, 'retrieveProblem', __data)
                .then(function (data) {
                try {
                    resolve(OutRetrieveProblemHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateSynapseProblemServiceClient.prototype.updateProblem = function (id, problem) {
        var _this = this;
        var __data = new InUpdateProblem();
        __data.id = id;
        __data.problem = problem;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateSynapseProblemServiceClient.ClassName, 'updateProblem', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateProblemHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateSynapseProblemServiceClient.prototype.unregisterItem = function (id) {
        var _this = this;
        var __data = new InUnregisterItem();
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateSynapseProblemServiceClient.ClassName, 'unregisterItem', __data)
                .then(function (data) {
                try {
                    resolve(OutUnregisterItemHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateSynapseProblemServiceClient.prototype.getRegisteredProblems = function (app) {
        var _this = this;
        var __data = new InGetRegisteredProblems();
        __data.app = app;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateSynapseProblemServiceClient.ClassName, 'getRegisteredProblems', __data)
                .then(function (data) {
                try {
                    resolve(OutGetRegisteredProblemsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateSynapseProblemServiceClient.prototype.checkRegisteredProblems = function (ids) {
        var _this = this;
        var __data = new InCheckRegisteredProblems();
        __data.ids = ids;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateSynapseProblemServiceClient.ClassName, 'checkRegisteredProblems', __data)
                .then(function (data) {
                try {
                    resolve(OutCheckRegisteredProblemsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateSynapseProblemServiceClient.prototype.getStats = function (id, version, query) {
        var _this = this;
        var __data = new InGetStats();
        __data.id = id;
        __data.version = version;
        __data.query = query;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateSynapseProblemServiceClient.ClassName, 'getStats', __data)
                .then(function (data) {
                try {
                    resolve(OutGetStatsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateSynapseProblemServiceClient.prototype.queryDataset = function (id, version, offset, format) {
        var _this = this;
        var __data = new InQueryDataset();
        __data.id = id;
        __data.version = version;
        __data.offset = offset;
        __data.format = format;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateSynapseProblemServiceClient.ClassName, 'queryDataset', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryDatasetHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateSynapseProblemServiceClient.prototype.problemSchema = function (id, problem) {
        var _this = this;
        var __data = new InProblemSchema();
        __data.id = id;
        __data.problem = problem;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateSynapseProblemServiceClient.ClassName, 'problemSchema', __data)
                .then(function (data) {
                try {
                    resolve(OutProblemSchemaHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateSynapseProblemServiceClient.prototype.problemSchemaSampleJson = function (id, problem) {
        var _this = this;
        var __data = new InProblemSchemaSampleJson();
        __data.id = id;
        __data.problem = problem;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateSynapseProblemServiceClient.ClassName, 'problemSchemaSampleJson', __data)
                .then(function (data) {
                try {
                    resolve(OutProblemSchemaSampleJsonHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateSynapseProblemServiceClient.prototype.testProblem = function (id, iterations) {
        var _this = this;
        var __data = new InTestProblem();
        __data.id = id;
        __data.iterations = iterations;
        return new Promise(function (resolve, reject) {
            _this._transport.send(PrivateSynapseProblemServiceClient.ClassName, 'testProblem', __data)
                .then(function (data) {
                try {
                    resolve(OutTestProblemHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    PrivateSynapseProblemServiceClient.PackageName = 'net.playq.services.synapse';
    PrivateSynapseProblemServiceClient.ClassName = 'PrivateSynapseProblemService';
    PrivateSynapseProblemServiceClient.FullClassName = 'net.playq.services.synapse.PrivateSynapseProblemService';
    return PrivateSynapseProblemServiceClient;
}());
exports.PrivateSynapseProblemServiceClient = PrivateSynapseProblemServiceClient;
var PrivateSynapseProblemServiceDispatcher = (function () {
    function PrivateSynapseProblemServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    PrivateSynapseProblemServiceDispatcher.prototype.getSupportedService = function () {
        return 'PrivateSynapseProblemService';
    };
    PrivateSynapseProblemServiceDispatcher.prototype.getSupportedMethods = function () {
        return PrivateSynapseProblemServiceDispatcher.methods;
    };
    PrivateSynapseProblemServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "registerProblem": {
                var obj_1 = new InRegisterProblem(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.registerProblem(context, obj_1.app, obj_1.problem, obj_1.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRegisterProblemHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "retrieveProblem": {
                var obj_2 = new InRetrieveProblem(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.retrieveProblem(context, obj_2.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRetrieveProblemHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateProblem": {
                var obj_3 = new InUpdateProblem(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateProblem(context, obj_3.id, obj_3.problem)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateProblemHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "unregisterItem": {
                var obj_4 = new InUnregisterItem(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.unregisterItem(context, obj_4.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUnregisterItemHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getRegisteredProblems": {
                var obj_5 = new InGetRegisteredProblems(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getRegisteredProblems(context, obj_5.app)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetRegisteredProblemsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "checkRegisteredProblems": {
                var obj_6 = new InCheckRegisteredProblems(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.checkRegisteredProblems(context, obj_6.ids)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutCheckRegisteredProblemsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getStats": {
                var obj_7 = new InGetStats(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getStats(context, obj_7.id, obj_7.version, obj_7.query)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetStatsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryDataset": {
                var obj_8 = new InQueryDataset(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryDataset(context, obj_8.id, obj_8.version, obj_8.offset, obj_8.format)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryDatasetHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "problemSchema": {
                var obj_9 = new InProblemSchema(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.problemSchema(context, obj_9.id, obj_9.problem)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutProblemSchemaHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "problemSchemaSampleJson": {
                var obj_10 = new InProblemSchemaSampleJson(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.problemSchemaSampleJson(context, obj_10.id, obj_10.problem)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutProblemSchemaSampleJsonHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "testProblem": {
                var obj_11 = new InTestProblem(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.testProblem(context, obj_11.id, obj_11.iterations)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutTestProblemHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by PrivateSynapseProblemServiceDispatcher."));
        }
    };
    PrivateSynapseProblemServiceDispatcher.methods = [
        "registerProblem",
        "retrieveProblem",
        "updateProblem",
        "unregisterItem",
        "getRegisteredProblems",
        "checkRegisteredProblems",
        "getStats",
        "queryDataset",
        "problemSchema",
        "problemSchemaSampleJson",
        "testProblem"
    ];
    return PrivateSynapseProblemServiceDispatcher;
}());
exports.PrivateSynapseProblemServiceDispatcher = PrivateSynapseProblemServiceDispatcher;
var PrivateSynapseProblemServiceServer = (function (_super) {
    __extends(PrivateSynapseProblemServiceServer, _super);
    function PrivateSynapseProblemServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    PrivateSynapseProblemServiceServer.prototype.registerProblem = function (context, app, problem, id) {
        throw new Error('Not implemented.');
    };
    PrivateSynapseProblemServiceServer.prototype.retrieveProblem = function (context, id) {
        throw new Error('Not implemented.');
    };
    PrivateSynapseProblemServiceServer.prototype.updateProblem = function (context, id, problem) {
        throw new Error('Not implemented.');
    };
    PrivateSynapseProblemServiceServer.prototype.unregisterItem = function (context, id) {
        throw new Error('Not implemented.');
    };
    PrivateSynapseProblemServiceServer.prototype.getRegisteredProblems = function (context, app) {
        throw new Error('Not implemented.');
    };
    PrivateSynapseProblemServiceServer.prototype.checkRegisteredProblems = function (context, ids) {
        throw new Error('Not implemented.');
    };
    PrivateSynapseProblemServiceServer.prototype.getStats = function (context, id, version, query) {
        throw new Error('Not implemented.');
    };
    PrivateSynapseProblemServiceServer.prototype.queryDataset = function (context, id, version, offset, format) {
        throw new Error('Not implemented.');
    };
    PrivateSynapseProblemServiceServer.prototype.problemSchema = function (context, id, problem) {
        throw new Error('Not implemented.');
    };
    PrivateSynapseProblemServiceServer.prototype.problemSchemaSampleJson = function (context, id, problem) {
        throw new Error('Not implemented.');
    };
    PrivateSynapseProblemServiceServer.prototype.testProblem = function (context, id, iterations) {
        throw new Error('Not implemented.');
    };
    return PrivateSynapseProblemServiceServer;
}(PrivateSynapseProblemServiceDispatcher));
exports.PrivateSynapseProblemServiceServer = PrivateSynapseProblemServiceServer;
//# sourceMappingURL=PrivateSynapseProblemService.js.map